import { useQuery } from "@tanstack/react-query";
import { recurringApi } from "../api/recurring";

export const useEventHistory = ({ projectId, activityId, dueDate }: { projectId: string | undefined, activityId: string | undefined, dueDate: string | undefined }) => {

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["evet-history", projectId, activityId, dueDate],
        queryFn: () => recurringApi.getRecurringTaskHistory({ projectId, activityId, dueDate }),
        enabled: !!activityId && !!projectId && !!dueDate,
    });

    return {
        eventData: data?.data ?? [],
        loading: isLoading,
        isError,
        error: isError ? "Failed to load operations." : null,
        refetch,
    };

};